
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/antara/setup/antara-customizations",
      function () {
        return require("private-next-pages/docs/antara/setup/antara-customizations/index.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/antara/setup/antara-customizations"])
      });
    }
  